export default __webpack_public_path__ + "static/icon-f6ce632128e294e84deecf333672d2a5.png";